import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatCLP } from "@/lib/api";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import { Trash, ShoppingCart, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Cart() {
  const { cart, remove } = useCart();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 py-10">
        <h1 className="font-display text-3xl font-800 tracking-tight mb-8">Tu carrito</h1>
        {cart.items.length === 0 ? (
          <div className="bg-white border border-border rounded-lg p-12 text-center" data-testid="cart-empty">
            <ShoppingCart size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">Tu carrito está vacío.</p>
            <Button onClick={() => navigate("/catalogo")} className="mt-5 bg-primary text-white hover:bg-blue-600">
              Explorar cursos
            </Button>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 space-y-3">
              {cart.items.map((it) => (
                <div key={it.course_id} className="bg-white border border-border rounded-lg p-4 flex gap-4 items-center"
                  data-testid={`cart-item-${it.course_id}`}>
                  <img src={it.image_url} alt={it.title} className="w-24 h-16 object-cover rounded shrink-0" />
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold truncate">{it.title}</h3>
                    <p className="text-sm text-muted-foreground">{formatCLP(it.price)}</p>
                  </div>
                  <button onClick={() => { remove(it.course_id); toast.success("Eliminado"); }}
                    data-testid={`cart-remove-${it.course_id}`}
                    className="p-2 text-muted-foreground hover:text-destructive transition-transform hover:-translate-y-[1px]">
                    <Trash size={20} />
                  </button>
                </div>
              ))}
            </div>
            <div className="lg:col-span-1">
              <div className="bg-white border border-border rounded-lg p-6 sticky top-24">
                <h2 className="font-display font-800 text-lg mb-4">Resumen</h2>
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-muted-foreground">{cart.items.length} curso(s)</span>
                  <span>{formatCLP(cart.total)}</span>
                </div>
                <div className="flex justify-between font-display font-800 text-xl mt-4 pt-4 border-t border-border">
                  <span>Total</span><span>{formatCLP(cart.total)}</span>
                </div>
                <Button onClick={() => navigate("/checkout")} data-testid="cart-checkout-btn"
                  className="w-full mt-6 bg-primary hover:bg-blue-600 text-white gap-2">
                  Ir a pagar <ArrowRight size={18} />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
